// extracted by mini-css-extract-plugin
module.exports = {"container":"InclustionsModale_container__224Ch","col-2":"InclustionsModale_col-2__WrWEE","list":"InclustionsModale_list__1I7d7","inclusion":"InclustionsModale_inclusion__CWdxV"};